import "core-js/modules/es.array.push.js";
import httpRequest from '@/request/index';
import { ref, onMounted, onBeforeMount, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';
import { showFailToast, showLoadingToast, closeToast } from 'vant';
import { useRouter } from "vue-router";
export default {
  setup() {
    const store = useStore();
    const router = useRouter();
    const list = ref([]);
    onBeforeMount(() => {
      document.getElementsByTagName("body")[0].className = "bg_body";
      showLoadingToast({
        message: '加载中',
        forbidClick: true
      });
      httpRequest({
        method: "get",
        url: "?file=address"
      }).then(res => {
        closeToast();
        if (res.state == 1) {
          list.value = res.list;
        } else {
          showFailToast(res.msg);
        }
      });
    });
    onBeforeUnmount(() => {
      document.body.removeAttribute("class", "bg_body");
    });
    onMounted(async () => {
      await store.dispatch("cklogin").then(res => {
        if (!store.state.isLogin) {
          router.replace("/login");
        }
      });
    });
    const goBack = () => {
      router.go(-1);
    };
    const addInfo = () => {
      router.push("/address/edit");
    };
    return {
      list,
      addInfo,
      goBack
    };
  }
};